var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.667,
    height: 26.667,
    viewBox: "0 0 26.667 26.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "telegram",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_12",
    "data-name": "Subtraction 12",
    d: "M13.333,26.667A13.333,13.333,0,0,1,3.905,3.905,13.333,13.333,0,0,1,22.762,22.761,13.246,13.246,0,0,1,13.333,26.667ZM13.3,17.874h0l3.712,2.736a1.25,1.25,0,0,0,.6.189c.368,0,.626-.283.744-.818L20.792,8.5a1.138,1.138,0,0,0-.135-.993.662.662,0,0,0-.535-.24,1.067,1.067,0,0,0-.361.067L5.443,12.85c-.485.19-.759.436-.751.676.007.2.219.387.583.5L8.94,15.173l8.5-5.354a.749.749,0,0,1,.392-.137c.089,0,.154.03.173.08s-.016.13-.1.208l-6.881,6.216-.263,3.779a.94.94,0,0,0,.748-.365L13.3,17.874Z",
    transform: "translate(0)",
    fill: "#033f6e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bc3db10365d5ecf4c32db2da73b7cc60.svg";
export { ForwardRef as ReactComponent };